import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import NewOrder from '../components/NewOrder';

export default function NewOrderPage() {
	const navigate = useNavigate();
	return (
		<div className="flex flex-col h-screen">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<NewOrder onClose={() => navigate('/leads')} />
			</div>
		</div>
	);
}
